import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { cmsApiRequest } from "../../Lib/Utils/ApiRequest";
import { getLocaleFromCookie } from "../../Lib/Utils/getLocaleFromCookie";
import { ICmsSpecialFareOfferResponse, ICmsTravelPassOfferResponse } from "../../Orchestrator/Types/Interface/ICMSOffers";

export const getCmsSpecialFareOffer = async () => {
  const ENDPOINTS = await getEndpoints();
  const endpoint = ENDPOINTS.getCmsSpecialFareOffersAPI;

  const params = new URLSearchParams();
  const locale = await getLocaleFromCookie();

  params.append("locale", locale);
  params.append("populate", "image");

  let endpointWithParams = `${endpoint}?${params.toString()}`;
  return await cmsApiRequest<ICmsSpecialFareOfferResponse>(
    endpointWithParams,
    "GET"
  );
}

export async function getCmsSpecialFareOfferDetail(slug: string) {
  const ENDPOINTS = await getEndpoints();
  const endpoint = ENDPOINTS.getCmsSpecialFareOffersAPI;

  const params = new URLSearchParams({
    locale: await getLocaleFromCookie(),
    // The detail banner needs `full` (Offer_Website.jpg, 1200x270) as well as
    // `image` (Offer_App.jpg, 419x212). Populating only `image` shipped the app
    // artwork to the website banner. Named explicitly rather than `*` to match
    // getCmsDestinationBySlug and to skip the unused `localizations` payload.
    // The list endpoint above deliberately stays on `populate=image`: its cards
    // render the app artwork, and `full` would be dead weight on every row.
    "populate[image]": "true",
    "populate[full]": "true",
    "filters[slug][$eq]": slug,
  });

  let endpointWithParams = `${endpoint}?${params.toString()}`;
  return await cmsApiRequest<ICmsSpecialFareOfferResponse>(endpointWithParams, "GET");
}
